import styled from "styled-components";
import { Link } from "react-router-dom";

export const Wrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media screen and (max-width: 1400px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 850px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const SubCategory = styled(Link)`
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
    min-width: 0;
    flex-basis: 0;
    flex-grow: 1;
    border-radius: 12px;
    border: 1px solid #CDE2FC;
    padding: 16px 20px;
`;

export const Icon = styled.img`
    width: 40px;
    height: auto;
    object-fit: contain;
`;

export const Content = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    row-gap: 4px;
    min-width: 0;
    flex-basis: 0;
    flex-grow: 1;
`

export const Title = styled.h3`
    color: #222;
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
`;

